import React, { useMemo } from 'react';
import { Group, Image as KonvaImage, Rect, Text } from 'react-konva';

import { getTextWidth } from '../lib';
import TableSize = GM.ReservesSchemas.TableSize;

const CanvasTableCapacity = ({
  capacity,
  tableSize,
  container,
  personImage,
  colors,
}: {
  capacity: number;
  tableSize?: TableSize;
  container: {
    width: number;
    borderWidth: number;
    borderRadius: number;
  };
  personImage: HTMLImageElement;
  colors: GM.ReservesSchemas.TableStateColorSet;
}) => {
  const { width, borderWidth, borderRadius } = container;
  const text = capacity > 1 ? capacity.toString() : '';

  const { fontSize, iconWidth, iconHeight, containerWidth, containerHeight, x, y, textX } =
    getCanvasTableCapacityLayout(tableSize, text, { width });

  const stripes = useStripePatternCanvas({ stripe: 4, gap: 6 });

  return (
    <Group
      clipX={-borderWidth}
      clipY={-borderWidth}
      clipWidth={containerWidth + borderWidth * 2}
      clipHeight={containerHeight + borderWidth}
    >
      <Rect
        width={containerWidth}
        height={containerHeight + borderRadius}
        fill={colors.head.bg}
        stroke={colors.head.border}
        strokeWidth={borderWidth}
        cornerRadius={borderRadius}
      />

      {colors.head.stripe && (
        <Rect
          x={-0.5}
          y={-0.5}
          width={containerWidth + 1}
          height={containerHeight + borderRadius}
          cornerRadius={borderRadius}
          fillPatternImage={stripes as unknown as HTMLImageElement}
          fillPatternRepeat="repeat"
          fillPatternRotation={45}
          listening={false}
        />
      )}

      <Group x={x} y={y}>
        {/* <CanvasImage src={personIcon} width={iconSize} height={iconSize} /> */}
        {/* <KonvaImage image={personImage} width={iconSize} height={iconSize} /> */}
        <KonvaImage y={1.5} image={personImage} width={iconWidth} height={iconHeight} />

        {capacity > 1 && textX && (
          <Text
            x={textX}
            text={text}
            fontSize={fontSize}
            fontFamily="Geologica"
            fill={colors.head.color}
          />
        )}
      </Group>
    </Group>
  );
};

export const getCanvasTableCapacityLayout = (
  tableSize: TableSize,
  capacityText: string,
  container: { width: number },
) => {
  let fontSize = 12;
  let iconWidth = 5.83;
  let iconHeight = 7.17;
  // В самой иконке есть небольшой gap, поэтому внешний gap отключен
  const gap = 2;
  // const gap = 0;
  let containerHeight = 15;
  let textX: number | null = null;

  if ('M' === tableSize) {
    fontSize = 14;
    iconWidth = 8.17;
    iconHeight = 10.03;
    containerHeight = 20;
  } else if ('L' === tableSize) {
    fontSize = 16;
    iconWidth = 9.33;
    iconHeight = 11.47;
    containerHeight = 24;
  }

  let width = iconWidth;

  if (capacityText) {
    textX = iconWidth + gap;
    width += gap + getTextWidth(capacityText, fontSize);
  }

  // @todo Нужно ли делать поправку по аналогии с getTextWidth?
  const height = Math.max(iconWidth, fontSize);

  return {
    width,
    height,
    containerWidth: container.width,
    containerHeight,
    iconWidth,
    iconHeight,
    fontSize,
    x: (container.width - width) / 2,
    y: (containerHeight - height) / 2,
    textX,
  };
};

function useStripePatternCanvas({ stripe, gap }: { stripe: number; gap: number }) {
  return useMemo(() => {
    const dpr = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;

    // Размер тайла: одна полоса + один промежуток
    const tile = stripe + gap;

    const c = document.createElement('canvas');
    c.width = Math.ceil(tile * dpr);
    c.height = Math.ceil(tile * dpr);

    const ctx = c.getContext('2d');
    ctx.scale(dpr, dpr);

    ctx.fillStyle = 'rgba(0, 0, 0, 0.3)';
    ctx.fillRect(0, 0, stripe, tile);
    return c;
  }, [stripe, gap]);
}

export default CanvasTableCapacity;
